module.exports = __webpack_public_path__ + "static/media/Rating Copy 2.a96b5c41.svg";